export const Bio = {
    name: "Udai Bhat",
    roles: [
      "Frontend Fiddler",
      "Backend Bandit",
      "Tech.Enthusiastic",
      "Version Control Villain",
    ],
    description:
      "I am a motivated and versatile individual, always eager to take on new challenges. With a passion for learning I am dedicated to delivering high-quality results. With a positive attitude and a growth mindset, I am ready to make a meaningful contribution and achieve great things.",
    github: "https://github.com/UDAIBHAT",
    resume:
      "https://drive.google.com/file/d/193g0Q4e1B05AsmqiuwWVE2do6wJQrU5n/view?usp=sharing",
    linkedin: "https://www.linkedin.com/in/udai-bhat-693b5122a?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
    twitter: "https://x.com/UdaiBhat?t=ArxOXokIDchclYAM8wJxNg&s=09",
    insta: "https://www.instagram.com/udaibhat_/",
    facebook: "https://www.facebook.com/profile.php?id=100082294936194",
  };
  
  export const skills = [
    {
      title: "Frontend",
      skills: [
        {
          name: "React ",
          image:
            "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
        },
  
        {
          name: "HTML",
          image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
        },
        {
          name: "CSS",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
        },
        {
          name: "JavaScript",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
        },
        {
          name: "Bootstrap",
          image:
            "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
        },
        {
          name: "Material UI",
          image:
            "data:image/png;base64,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",
        },
  
      ],
    },
    {
      title: "Backend",
      skills: [
        {
          name: "Node Js",
          image: "https://nodejs.org/static/images/logo.svg",
        },
        {
          name: "Express Js",
          image:
            "data:image/png;base64,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",
        },
  
        {
          name: "MySQL",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
        },
  
        {
          name: "Java",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/java/java-original.svg",
        },
        {
          name: "PHP",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/PHP-logo.svg/1200px-PHP-logo.svg.png",
        },
      ],
    },
    // {
    //   title: "Android",
    // skills: [
      
    // ],
    // },
    {
      title: "Others",
      skills: [
        {
          name: "Git",
          image:
            "https://git-scm.com/images/logos/downloads/Git-Icon-1788C.png",
        },
        {
          name: "GitHub",
          image:
            "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
        },
        {
          name: "Docker",
          image:
            "https://raw.githubusercontent.com/devicons/devicon/master/icons/docker/docker-original-wordmark.svg",
        },
  
        {
          name: "VS Code",
          image:
            "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
        },
  
        {
          name: "VSDC",
          image:
            "https://i.pcmag.com/imagery/reviews/04EpxWvtWVk43XiaJZF6HRs-4.fit_scale.size_760x427.v1572662629.jpg",
        },
  
      ],
    },
  ];
  
  export const experiences = [
    {
      id: 0,
      img: "https://static.toiimg.com/thumb/msid-68366714,width-400,height-225,resizemode-72/68366714.jpg",
      role: "Python ",
      company: "Indian Institute of Technology, Bombay",
      date: "Oct 2023",
      desc: "Successfully completed Pyhton 3.4.3 test(remote) organised at L.D.College of Engineering by Huma Syed with course material provided by IIT Bombay and scored 92% in this test.",
      skills: [
        "Python",
  
      ],
      doc: "https://raw.githubusercontent.com/UDAIBHAT/certificate-pics/main/c2.jpeg",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSWaSJcjWqkjFNOwjzKhLDbERR_ynQGOGLcZQ&s",
      role: "Associate of the Conference (ACA)",
      company: "International MUN ",
      date: "Aug 2022",
      desc: "Awarded the Best Delegate at the International Model United Nations. A Conference held by UNICEF & WHO in accordance with Australian Embassy.This prestigious recognition highlights my exceptional diplomacy, leadership, and negotiation skills demonstrated during the conference. My ability to engage with complex global issues and collaborate effectively with fellow delegates has undoubtedly contributed to my success in representing my country on an assigned role.",
      skills: [
        "Global Issues",
        "Critical Thinking",
        "Public Speaking",
      ],
      doc: "https://raw.githubusercontent.com/UDAIBHAT/certificate-pics/main/c1.jpeg?token=GHSAT0AAAAAACS5QBGTSPURM7TNGAWVQGOEZS6CU7Q",
    },
  
  
  
  
  ];
  
  export const education = [
    {
      id: 0,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSRfktdqhQSWpJmqCfTzhHNjmvjgyFNbnLJ-w&s",
      school: "Lalbhai Dalpatbhai (L.D) College of Engineering, Ahmedabad",
      date: "Aug 2021 - Jun 2025",
      grade: "7.96 CGPA",
      desc: "I am currently pursuing a Bachelor's degree in Computer Science and Engineering at Lalbhai Dalpatbhai (L.D) College of Engineering, Ahmedabad. I have completed 6 semesters and have a CGPA of 7.96 . I have taken courses in Data Structures, Algorithms, Object-Oriented Programming, Database Management Systems, Operating Systems, and Computer Networks, among others.",
      degree: "Bachelor of Technology - BTech, Computer Science and Engineering",
    },
    {
      id: 1,
      img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTxitO6e4hLFDpjMzyKJ3V75zR9et-81hgf9lpkwlJfYb-HIDhlr5x_r4M2FEB9iDxPd20",
      school: "Govt.Mixed Hr. Sec. School, Bantalab, Jammu, J&K",
      date: "Apr 2019 - Mar 2021",
      grade: "96.00%",
      desc: "I completed my class 12 high school education at Govt.Mixed Hr. Sec. School, Bantalab where I studied Science with Physical Education.",
      degree: "Higher Secondary, Science (Non-Medical)",
    },
    {
      id: 2,
      img: "https://lh6.googleusercontent.com/proxy/uegnPippuw1eX02mq8kbSvrx5ME2CcmQ60qJvneu1EwRDMSzeqKanS8M_5qNikmR9ySGouTONQGnwWR-pap_V-O8RKGdzYVYOiFNd4THZY05Saes4LKeCmkb5y40YSPtSw",
      school: "Crescent Public School, Janipur, Jammu",
      date: "Apr 2018 - Apr 2019",
      grade: "85%",
      desc: "I completed my class 10 education at Crescent Public School, Janipur, where I studied Science with Computer Application.",
      degree: "Secondary, Science with Computer",
    },
  ];
  
  export const projects = [
    {
      id: 0,
      title: "COVID-19 Awarness",
      date: "Aug 2021 - Sep 2021",
      description:
        "The COVID-19 Awareness Website is a comprehensive platform designed to educate the public about COVID-19, provide real-time updates, and facilitate donations to support relief efforts. Built using HTML, CSS, and JavaScript, the site integrates the PayPal Payment API to enable secure and efficient donations.",
      image:
        "https://raw.githubusercontent.com/UDAIBHAT/Covid-19_Awareness_website/master/s1.png",
      tags: [
        "HTML",
        "CSS",
        "JavaScript",
        "API"
      ],
      category: "web app",
      github: "https://github.com/UDAIBHAT/Covid-19_Awareness_website.git",
      webapp: "https://udaibhat.github.io/Covid-19_Awareness_website/",
    },
    {
      id: 1,
      title: "WEATHER Web_App",
      date: "Apr 2022 - May 2022",
      description:
        "The Weather App project is designed to provide users with real-time weather information for any location worldwide. Using HTML, CSS, and JavaScript, the app fetches data from a weather API and displays it in a user-friendly interface. The primary goal is to create an intuitive, responsive, and visually appealing application that helps users stay informed about weather conditions.",
      image:
        "https://raw.githubusercontent.com/UDAIBHAT/WHEATHER_APP/master/Weather-App.jpg",
      tags: ["HTML",
        "CSS",
        "JavaScript",
        "API"],
      category: "web app",
      github: "https://github.com/UDAIBHAT/WEATHER_APP.git",
      webapp: "https://udaibhat.github.io/WEATHER_APP/",
    },
    {
      id: 2,
      title: "Typing_SpeedTest Web_App",
      date: "July 2022 - Aug 2022",
      description:
        "This website is used to check the typing speed of the user. It will the give the information of how many seconds require for typing the particular sentence.",
      image:
        "https://raw.githubusercontent.com/UDAIBHAT/TYPING_SPEED_TEST-website/master/screenshots/ss2.png",
      tags: [
        "HTML",
        "CSS",
        "JavaScript"
      ],
      category: "web app",
      github: "https://github.com/UDAIBHAT/TYPING_SPEED_TEST-website.git",
      webapp: "https://udaibhat.github.io/TYPING_SPEED_TEST-website/",
    },

    
    {
      id: 3,
      title: "BLOOD-BUDDY",
      date: "Sep 2023",
      description:
        "Blood Buddy is a comprehensive web application aimed at enhancing the process of blood donation and transfusion. It serves as a platform where both blood donors and recipients can connect efficiently. The application facilitates secure user registration and login functionalities, ensuring privacy and security for all users",
      image:
        "https://raw.githubusercontent.com/UDAIBHAT/certificate-pics/main/c4.png",
      tags: ["HTML",
        "CSS",
        "JavaScript",
      "PHP",
    "MySql",
  "Bootstrap(Framework)"],
      category: "web app",
      github: "https://github.com/UDAIBHAT/The-Blood-Buddy.git",
      webapp: "https://bloodbuuddy.000webhostapp.com/",
    },
  
  
  
  
    {
      id: 4,
      title: "Virtual Keyboard",
      date: "Sept 2023",
      description:
        "An Aesthetic Virtual Keyboard on the screen with all the features and a display. TRY IT !!!!!!!!!",
      image:
        "https://raw.githubusercontent.com/UDAIBHAT/Virtual_Keyboard/master/imgg.png",
      tags: ["HTML",
        "CSS3",
        "JavaScript"],
      category: "web app",
      github: "https://github.com/UDAIBHAT/Virtual_Keyboard.git",
      webapp: "https://udaibhat.github.io/Virtual_Keyboard/",
    },
    {
      id: 5,
      title: "CHESS GAME",
      date: "DEC 2023",
      description:
        "The JavaScript Chess Game project is designed to create an interactive and fully functional chess game playable in a web browser. The project involves developing both the front-end user interface and the back-end game logic using HTML, CSS, and JavaScript. The primary goal is to provide an engaging and educational experience for users interested in chess and web development.",
      image:
        "https://raw.githubusercontent.com/UDAIBHAT/PROJECT_CHESS/master/chess%20ss.png",
      tags: ["HTML",
        "CSS",
        "JavaScript"],
      category: "web app",
      github: "https://github.com/UDAIBHAT/PROJECT_CHESS.git",
      webapp: "https://udaibhat.github.io/PROJECT_CHESS/",
    },
  
  
    {
      id: 6,
      title: "Face Recognition",
      date: "Jun 2024",
      description:
        "This Python project leverages OpenCV, face_recognition, SQLite3, and pyttsx3 to implement a facial recognition system for user registration and authentication. Users can register by capturing their face via webcam, which is then encoded and stored in an SQLite database. For authentication, the system captures real-time webcam images, extracts facial encodings, and compares them with the stored data to identify users. Upon successful identification, it provides audible feedback using text-to-speech and performs designated post-authentication tasks. The system also uses threading for concurrent tasks, logging for debugging, and signal handling for graceful termination.",
      image:
        "https://readwrite.com/wp-content/uploads/2019/11/Facial-Recognition-%E2%80%93-Shaping-the-future-of-Identity-Verification-Market-900x581.jpg",
      tags: ["Python", "Open CV", "Pyttxs3", "SQlite3", "face-recognisation"],
      category: "machine learning",
      github: "https://github.com/UDAIBHAT/FACE-RECOGNITION.git",
      webapp: "",
      member: [
        {
          name: "Udai Bhat",
          img: "https://avatars.githubusercontent.com/u/97431624?v=4",
          linkedin: "https://www.linkedin.com/in/udai-bhat-693b5122a/?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=android_app",
          github: "https://github.com/UDAIBHAT",
        },
        {
          name: "Vaishnavi Patel",
          img: "https://avatars.githubusercontent.com/u/135328382?v=4",
          linkedin: "https://www.linkedin.com/in/vaishnavi-patel-8115782ab/",
          github: "https://github.com/Vaishnavipatel26",
        },
      ],
    },
    {
      id: 7,
      title: "SNAKE - GAME",
      date: "Jun 2021",
      description:
        "Created a Snake game using HTML, JavaScript, and CSS is a fun and educational project that introduces key web development concepts. In this game, players control a snake to collect food, growing longer with each piece of food consumed. The game involves using HTML to structure the page, CSS to style the elements, and JavaScript to handle the game logic, including movement, collision detection, and score tracking. This project is an excellent way to practice event handling and basic game development techniques.",
      image:
        "https://raw.githubusercontent.com/UDAIBHAT/SNAKE-GAME/master/snake.jpg",
      tags: ["HTML",
        "CSS",
        "JavaScript"],
      category: "web app",
      github: "https://github.com/UDAIBHAT/SNAKE-GAME.git",
      webapp: "https://udaibhat.github.io/SNAKE-GAME/",
    },
    {
      id: 8,
      title: "Music-Player",
      date: "Jan 2023",
      description:
        "This Music Player is allows you to play music with lyrics on web, TRY It !!!!!!!!!!!!!",
      image:
        "https://raw.githubusercontent.com/UDAIBHAT/Web_Music_Player/master/music.png",
      tags: ["HTML",
        "CSS",
        "JavaScript"],
      category: "web app",
      github: "https://github.com/UDAIBHAT/Web_Music_Player.git",
      webapp: "https://udaibhat.github.io/Web_Music_Player/",
    },
  ];
  
  
  